import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";
import { trustDropDownData } from "./DropDownData";

export const TrustDropDown = ({
  value,
  isMulti = false,
  isShowAll = false,
  isFirstSelected = false,
  onSelect,
  selectedId,
  placeholder,
  isClearShow,
  ...props
}) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    loadTrustList();
    return () => {
      setList([]);
    };
  }, []);

  const loadTrustList = () => {
    trustDropDownData((data, error) => {
      if (error === null) {
        let finalList = data;
        if (isShowAll) {
          finalList = [{ id: 0, label: "All", value: "All" }, ...data];
        }
        setList(finalList);
        if (isFirstSelected && finalList.length > 0 && !value) {
          onSelect(finalList[0]);
        }
      }
    });
  };

  useEffect(() => {
    if (selectedId && list.length > 0) {
      const selectedOption = list.find((option) => option.id === selectedId);
      if (selectedOption) {
        onSelect(selectedOption);
      }
    }
  }, [list, selectedId]);

  return (
    <RSelect
      options={list}
      isMulti={isMulti}
      placeholder={placeholder}
      selectedId={selectedId}
      isClearable
      value={
        value ??
        (isFirstSelected && value && list.length > 0 && selectedId === undefined
          ? list[0]
          : isShowAll
          ? list[0] || null
          : null)
      }
      onChange={(e) => {
        if (isShowAll === false) {
          onSelect(e);
        } else {
          e.id === 0 ? onSelect(undefined) : onSelect(e);
        }
      }}
      {...props}
    />
  );
};
